import { Injectable } from '@angular/core';
import { PostmethodService } from '../../app-config/postmethod.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProductColorService {

  constructor(private ws: PostmethodService) { }

  productColorCrud(request: any) {
    return this.ws.wsPost(request, environment.masterUrl + "productColorMaster");
  }
}
